import { baseApi } from './apiConfig';


export const resetMessageCount = (userID) => {

    return baseApi
      .post(`/portal/resetMessageCount/${userID}`)
      .then(response => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
      .catch(error => {
        return error;
      });
  

}

export const getAlertData =  () => {
  try {
    const cookies = document.cookie;

    return baseApi
      .get('/portal/allAlerts', {
        header: {
          Cookies: cookies,
        },
      })
      .then(response => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
      .catch(error => {
        return error;
      });
  } catch (error) {
    // console.log('insideGetAlert error' + error);
  }
};



